import React, {FC, PropsWithChildren} from 'react';

import {NavigationBlockingProvider} from '../../../srcCommon/app/navigationBlockingProvider';
import {BrowserProvider} from '../../../srcCommon/browser/browserProvider';
import {RenderProfilerProvider} from '../../../srcCommon/services/performanceMetrics/renderProfilerProvider';
import {TableLoadingRowsProvider} from '../common/table/tableLoadingRowsProvider';

// Providers for modules from the libs/shared packages. These include frontend UI modules
// which should not be provided on mobile. For cross-platform modules, use SharedProviders.
export const SharedUiProviders: FC<PropsWithChildren<unknown>> = ({children}) => (
  <TableLoadingRowsProvider>
    <NavigationBlockingProvider>
      <BrowserProvider>
        <RenderProfilerProvider>{children}</RenderProfilerProvider>
      </BrowserProvider>
    </NavigationBlockingProvider>
  </TableLoadingRowsProvider>
);
